export const addCommaToNumber = (num) => {
  if (typeof num === 'number') {
    const formatted = num.toFixed(2);

    const withoutZeroDecimal = formatted.endsWith('.00') ? formatted.slice(0, -3) : formatted;

    return withoutZeroDecimal.replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
  }

  return num;
};
